module.exports = __webpack_public_path__ + "img/widget-img.ec1cb292.png";